import { OnInteraction } from './on-interaction.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class SeenFeedback extends OnInteraction {}
